<template>
  <v-container>
    <v-snackbar top v-model="alert" multi-line :color="alert_mode">
      {{ alert_text }}
      <v-btn text @click="alert = false">{{$t('close')}}</v-btn>
    </v-snackbar>
    <h2 class="mt-5 mb-10">{{$t('approval')}}</h2>
    <v-card class="px-6 pb-0 mb-3">
      <v-row>
        <v-col md="3" class="pb-0">
          <v-menu ref="menu" v-model="menu_start" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field :value="dateFormatted(start_date)"  :locale="$t('locale')" :label="$t('start_date')" prepend-icon="mdi-calendar" readonly
                v-on="on" color="primary"></v-text-field>
            </template>
            <v-date-picker  :locale="$t('locale')" v-model="start_date" @change="onStartDateChange()" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3" class="pb-0">
          <v-menu ref="menu" v-model="menu_end" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field :value="dateFormatted(end_date)" :label="$t('end_date')" prepend-icon="mdi-calendar" readonly
                v-on="on" color="primary"></v-text-field>
            </template>
            <v-date-picker v-model="end_date"  :locale="$t('locale')" @change="onEndDateChange()" no-title scrollable :min="start_date">
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3" class="pa-6">
          <v-btn block color="primary" @click="searching" :disabled="loadingDownload" :loading="loadingDownload">
            <v-icon>mdi-magnify</v-icon>{{$t('search')}}
          </v-btn>
        </v-col>
        <v-col md="3" class="pa-6">
          <div v-if="!checkFileExists && !loadingDownload">
            <download-excel :data="approval_report" worksheet="Approval" :name="title">
              <v-btn block outlined color="primary" :loading="loadingDownload">
                <v-icon>mdi-download</v-icon>{{$t('download_report')}}
              </v-btn>
            </download-excel>
          </div>
          <div v-else>
            <v-btn block outlined color="primary" :disabled="checkFileExists || loadingDownload"
              :loading="loadingDownload">
              <v-icon>mdi-download</v-icon>{{$t('download_report')}}
            </v-btn>
          </div>
        </v-col>
        <!-- <v-col md="3">
          <v-combobox
            label="Select a category and status approval"
            :items="approval"
            item-text="status"
            multiple
          ></v-combobox>
        </v-col>-->
      </v-row>
    </v-card>
    <v-row>
      <v-col md="4">
        <v-select :items="categoryLeave" :placeholder="$t('select_category_report')" item-text="name"
          item-value="id" @change="downloadReportApproval" v-model="selectedCategory"></v-select>
      </v-col>
      <v-col md="6" offset="2">
        <v-text-field hide-details :label="$t('find_an_approval')" :rules="[validator.alfaNumberNotRequired]" prepend-inner-icon="mdi-magnify" single-line
          v-model="search"></v-text-field>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="approval" class="elevation-1" :search="search" v-if="!loading"
          :sort-by="['submit_timestamp', 'status']" :sort-desc="[true, true]" :no-data-text="$t('no_data')" multi-sort
          :footer-props="{ 'items-per-page-options': [10, 50, 100],
          'items-per-page-text': $t('rows_per_page')  }">
           <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
          <template v-slot:item.category="{ item }">
            <div>{{$t(item.category.toLowerCase())}}</div>
          </template>
          <template v-slot:item.status="{ item }">
            <div v-if="item.status == 'Need Approval' && item.category == 'Leave'">
              <v-btn small color="primary" @click="timeoffDetailsDialog(item)">{{$t('need_approval')}}</v-btn>
            </div>
            <div v-if="item.status == 'Need Approval' && item.category == 'Correction'">
              <v-btn small color="primary" @click="openDetailsDialog(item)">{{$t('need_approval')}}</v-btn>
            </div>
            <div v-if="item.status == 'Need Approval' && item.category == 'Claim'">
              <v-btn small color="primary" @click="claimDialog(item)">{{$t('need_approval')}}</v-btn>
            </div>
            <div v-if="item.status == 'Need Approval' && item.category == 'Overtime'">
              <v-btn small color="primary" @click="OvertimeDialog(item)">{{$t('need_approval')}}</v-btn>
            </div>
            <div v-if="item.status == 'Need Approval' && item.category == 'Switch-schedule'">
              <v-btn small color="primary" @click="essDialog(item)">{{$t('need_approval')}}</v-btn>
            </div>
            <div v-if="item.status == 'cancelled' && item.category == 'Leave'">
              <v-btn small outlined color="error" @click="timeoffDetailsDialog(item)">{{$t('cancelled')}}</v-btn>
            </div>
            <div v-if="item.status == 'cancelled' && item.category == 'Correction'">
              <v-btn small outlined color="error" @click="openDetailsDialog(item)">{{$t('cancelled')}}</v-btn>
            </div>
            <div v-if="item.status == 'cancelled' && item.category == 'Claim'">
              <v-btn small outlined color="error" @click="claimDialog(item)">{{$t('cancelled')}}</v-btn>
            </div>
            <div v-if="item.status == 'cancelled' && item.category == 'Overtime'">
              <v-btn small outlined color="error" @click="OvertimeDialog(item)">{{$t('cancelled')}}</v-btn>
            </div>
            <div v-if="item.status == 'cancelled' && item.category == 'Switch-schedule'">
              <v-btn small outlined color="error" @click="essDialog(item)">{{$t('cancelled')}}</v-btn>
            </div>
            <div v-if="item.status == 'l1Revised' && item.category == 'Correction'">
              <v-btn outlined small color="orange" @click="viewDetailsDialog(item)">{{$t('need_revision')}}</v-btn>
            </div>
            <div v-if="item.status == 'l2Revised' && item.category == 'Correction'">
              <v-btn outlined small color="orange" @click="viewDetailsDialog(item)">{{$t('need_revision')}}</v-btn>
            </div>
            <div v-if="item.status == 'l1Revised' && item.category == 'Leave'">
              <v-btn outlined small color="orange" @click="revisedTimeoffDialog(item)">{{$t('need_revision')}}</v-btn>
            </div>
            <div v-if="item.status == 'l2Revised' && item.category == 'Leave'">
              <v-btn outlined small color="orange" @click="revisedTimeoffDialog(item)">{{$t('need_revision')}}</v-btn>
            </div>
            <div v-if="item.status == 'l1Revised' && item.category == 'Claim'">
              <v-btn outlined small color="orange" @click="revisedClaimDialog(item)">{{$t('need_revision')}}</v-btn>
            </div>
            <div v-if="item.status == 'l2Revised' && item.category == 'Claim'">
              <v-btn outlined small color="orange" @click="revisedClaimDialog(item)">{{$t('need_revision')}}</v-btn>
            </div>
            <div v-if="item.status == 'l1Revised' && item.category == 'Overtime'">
              <v-btn outlined small color="orange" @click="revisedOvertimeDialog(item)">{{$t('need_revision')}}</v-btn>
            </div>
            <div v-if="item.status == 'l2Revised' && item.category == 'Overtime'">
              <v-btn outlined small color="orange" @click="revisedOvertimeDialog(item)">{{$t('need_revision')}}</v-btn>
            </div>
            <div v-if="item.status == 'l1Revised' && item.category == 'Switch-schedule'">
              <v-btn outlined small color="orange" @click="revisedEssDialog(item)">{{$t('need_revision')}}</v-btn>
            </div>
            <div v-if="item.status == 'l2Revised' && item.category == 'Switch-schedule'">
              <v-btn outlined small color="orange" @click="revisedEssDialog(item)">{{$t('need_revision')}}</v-btn>
            </div>

            <!-- Correction -->
            <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Correction' && item.approver2Id != firebase_uid">
              <v-btn outlined small color="success" @click="approvedDetailsDialog(item)">{{$t('approved')}}</v-btn>
            </div>
            <div v-else-if="(item.status == 'l2Approved' || item.status == 'approved') && item.category == 'Correction'">
              <v-btn outlined small color="success" @click="approvedDetailsDialog(item)">{{$t('approved')}}</v-btn>
            </div>

            <!-- Leave -->
            <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Leave' && item.approver2Id != firebase_uid">
              <v-btn outlined small color="success" @click="approveTimeoffDialog(item)">{{$t('approved')}}</v-btn>
            </div>
            <div v-else-if="(item.status == 'l2Approved' || item.status == 'approved') && item.category == 'Leave'">
              <v-btn outlined small color="success" @click="approveTimeoffDialog(item)">{{$t('approved')}}</v-btn>
            </div>

            <!-- Claim -->
            <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Claim' && item.approver2Id != firebase_uid">
              <v-btn outlined small color="success" @click="approveClaimDialog(item)">{{$t('approved')}}</v-btn>
            </div>
            <div v-else-if="(item.status == 'l2Approved' || item.status == 'approved') && item.category == 'Claim'">
              <v-btn outlined small color="success" @click="approveClaimDialog(item)">{{$t('approved')}}</v-btn>
            </div>

            <!-- Overtime -->
            <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Overtime' && item.approver2Id != firebase_uid">
              <v-btn outlined small color="success" @click="approveOvertimeDialog(item)">{{$t('approved')}}</v-btn>
            </div>
            <div v-else-if="(item.status == 'l2Approved' || item.status == 'approved') && item.category == 'Overtime'">
              <v-btn outlined small color="success" @click="approveOvertimeDialog(item)">{{$t('approved')}}</v-btn>
            </div>

            <!-- ESS -->
            <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Switch-schedule' && item.approver2Id != firebase_uid">
              <v-btn outlined small color="success" @click="approveEssDialog(item)">{{$t('approved')}}</v-btn>
            </div>
            <div v-else-if="(item.status == 'l2Approved' || item.status == 'approved') && item.category == 'Switch-schedule'">
              <v-btn outlined small color="success" @click="approveEssDialog(item)">{{$t('approved')}}</v-btn>
            </div>

            <!-- Start Handle l1approved -->
            <!-- If 1 layer and user is approver 2 (Approved) -->
            <template v-if="item.type === 1">
              <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Leave' && item.approver2Id == firebase_uid">
                <v-btn small color="primary" @click="approveTimeoffDialog(item)">{{$t('approved')}}</v-btn>
              </div>
              <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Correction' && item.approver2Id == firebase_uid">
                <v-btn small color="primary" @click="approvedDetailsDialog(item)">{{$t('approved')}}</v-btn>
              </div>
              <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Claim' && item.approver2Id == firebase_uid">
                <v-btn small color="primary" @click="approveClaimDialog(item)">{{$t('approved')}}</v-btn>
              </div>
              <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Overtime' && item.approver2Id == firebase_uid">
                <v-btn small color="primary" @click="approveOvertimeDialog(item)">{{$t('approved')}}</v-btn>
              </div>
              <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Switch-schedule' && item.approver2Id == firebase_uid">
                <v-btn small color="primary" @click="approveEssDialog(item)">{{$t('approved')}}</v-btn>
              </div>
            </template>

            <!-- If 2 layer and user is approver 2 (Need Approval) -->
            <template v-else>
              <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Leave' && item.approver2Id == firebase_uid">
                <v-btn small color="primary" @click="timeoffDetailsDialog(item)">{{$t('need_approval')}}</v-btn>
              </div>
              <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Correction' && item.approver2Id == firebase_uid">
                <v-btn small color="primary" @click="openDetailsDialog(item)">{{$t('need_approval')}}</v-btn>
              </div>
              <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Claim' && item.approver2Id == firebase_uid">
                <v-btn small color="primary" @click="claimDialog(item)">{{$t('need_approval')}}</v-btn>
              </div>
              <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Overtime' && item.approver2Id == firebase_uid">
                <v-btn small color="primary" @click="OvertimeDialog(item)">{{$t('need_approval')}}</v-btn>
              </div>
              <div v-if="(item.status == 'l1Approved' || item.status == 'approved') && item.category == 'Switch-schedule' && item.approver2Id == firebase_uid">
                <v-btn small color="primary" @click="essDialog(item)">{{$t('need_approval')}}</v-btn>
              </div>
            </template>
            <!-- End Handle l1approved -->
            
            <div v-if="item.status == 'l1Rejected' && item.category == 'Correction'">
              <v-btn outlined small color="error" @click="viewDetailsDialog(item)">{{$t('rejected')}}</v-btn>
            </div>
            <div v-if="item.status == 'l2Rejected' && item.category == 'Correction'">
              <v-btn outlined small color="error" @click="viewDetailsDialog(item)">{{$t('rejected')}}</v-btn>
            </div>
            <div v-if="item.status == 'l1Rejected' && item.category == 'Leave'">
              <v-btn outlined small color="error" @click="revisedTimeoffDialog(item)">{{$t('rejected')}}</v-btn>
            </div>
            <div v-if="item.status == 'l2Rejected' && item.category == 'Leave'">
              <v-btn outlined small color="error" @click="revisedTimeoffDialog(item)">{{$t('rejected')}}</v-btn>
            </div>
            <div v-if="item.status == 'l1Rejected' && item.category == 'Claim'">
              <v-btn outlined small color="error" @click="revisedClaimDialog(item)">{{$t('rejected')}}</v-btn>
            </div>
            <div v-if="item.status == 'l2Rejected' && item.category == 'Claim'">
              <v-btn outlined small color="error" @click="revisedClaimDialog(item)">{{$t('rejected')}}</v-btn>
            </div>
            <div v-if="item.status == 'l1Rejected' && item.category == 'Overtime'">
              <v-btn outlined small color="error" @click="revisedOvertimeDialog(item)">{{$t('rejected')}}</v-btn>
            </div>
            <div v-if="item.status == 'l2Rejected' && item.category == 'Overtime'">
              <v-btn outlined small color="error" @click="revisedOvertimeDialog(item)">{{$t('rejected')}}</v-btn>
            </div>
            <div v-if="item.status == 'l1Rejected' && item.category == 'Switch-schedule'">
              <v-btn outlined small color="error" @click="revisedEssDialog(item)">{{$t('rejected')}}</v-btn>
            </div>
            <div v-if="item.status == 'l2Rejected' && item.category == 'Switch-schedule'">
              <v-btn outlined small color="error" @click="revisedEssDialog(item)">{{$t('rejected')}}</v-btn>
            </div>
          </template>
          <template v-slot:item.submit_time="{ item }">
            <div>{{ milisToDate(item.submit_timestamp) }}</div>
          </template>
          <template v-slot:item.status_comment="{ item }">
            <div v-if="item.timeoff_comments.status == 'submitted'">{{$t('need_approval')}}</div>
            <div v-if="item.timeoff_comments.status == 'approved'">You have agreed to this request</div>
            <div v-if="item.timeoff_comments.status == 'revised'">Waiting for data revision</div>
            <div v-if="item.timeoff_comments.status == 'rejected'">You have rejected this request</div>
          </template>
          <!-- <template v-slot:item.category="{ item }">
            <div v-if="item.category == 'Leave'">Leave</div>
            <div v-if="item.category == 'Correction'">Correction</div>
          </template>-->
        </v-data-table>
      </v-col>
    </v-row>
    <v-skeleton-loader class="mx-auto" type="table-tbody" v-if="loading"></v-skeleton-loader>
    <correction @closeDetails="closeDetails" :allApprover="allApprover" :approvalType="approval_type" @closeComments="closeComments" @cancelReject="cancelReject"
      :detailsDialog="detailsDialog" :firebaseUID="firebaseUID" :viewDialog="viewDialog"
      :loadingDetails="loadingDetails" :details_approvall="details_approvall" :approval_name="approval_name"
      :name_approver="name_approver" :name_approver2="name_approver2" :data_before="data_before"
      :data_after="data_after" :milisToHour="milisToHour" :commentApprover="commentApprover"
      :checkReasonColor="checkReasonColor" :checkReasonApproveColor="checkReasonApproveColor"
      :approveDialog="approveDialog" :checkNoteApproveColor="checkNoteApproveColor" @rejectItem="rejectItem"
      :checkApprover="checkApprover" :commentDialog1="commentDialog1" :approveItem="approveItem"
      :approverCondition="approverCondition">
    </correction>
    <leave @closeDetails="closeDetails" :allApprover="allApprover" :approvalType="approval_type" @closeComments="closeComments" :revisedTimeoff="revisedTimeoff"
      :approveTimeoff="approveTimeoff" :timeoff_approver="timeoff_approver" :timeoff_approver2="timeoff_approver2"
      :timeoffDialog="timeoffDialog" :timeoff_image="timeoff_image" :details_timeoff="details_timeoff"
      :timeOff_name="timeOff_name" :milisToDate="milisToDate" :leaveName="leaveName" :firebaseUID="firebaseUID"
      :timeoff_comments="timeoff_comments" :milisToHour="milisToHour" :index="index" :commentDialog="commentDialog"
      :close="close" :commentApprover="commentApprover" :rules="rules" :comment_value="comment_value"
      :approveItem="approveItem" :loadingDetails="loadingDetails" @rejectItem="rejectItem" @cancelReject="cancelReject"
      :checkApprover="checkApprover" :approverCondition="approverCondition"></leave>
    <overtime @closeDetails="closeDetails" :allApprover="allApprover" :approvalType="approval_type" @closeComments="closeComments" :overtime_image="overtime_image"
      :loadingDetails="loadingDetails" :overtime_name="overtime_name" :details_overtime="details_overtime"
      :OvertimeNeedApproval="OvertimeNeedApproval" :index="index" :milisToDate="milisToDate" :firebaseUID="firebaseUID"
      :overtime_comments="overtime_comments" :milisToHour="milisToHour" :milisToTime="milisToTime"
      :overtimeName="overtimeName" :data_overtime="data_overtime" :overtime_approver="overtime_approver"
      :overtime_approver2="overtime_approver2" :approveOvertime="approveOvertime" :revisedOvertime="revisedOvertime"
      :close="close" :commentApprover="commentApprover" :rules="rules" :comment_value="comment_value"
      :approveItem="approveItem" @rejectItem="rejectItem" @cancelReject="cancelReject" :checkApprover="checkApprover"
      :approverCondition="approverCondition">
    </overtime>
    <reimburse @closeDetails="closeDetails" :allApprover="allApprover" :approvalType="approval_type" @closeComments="closeComments" :claim_image="claim_image"
      :loadingDetails="loadingDetails" :claim_name="claim_name" :details_claim="details_claim"
      :claimNeedApproval="claimNeedApproval" :index="index" :milisToDate="milisToDate" :firebaseUID="firebaseUID"
      :claim_comments="claim_comments" :milisToHour="milisToHour" :milisToTime="milisToTime" :claimName="claimName"
      :data_claim="data_claim" :claim_approver="claim_approver" :claim_approver2="claim_approver2"
      :approveClaim="approveClaim" :revisedClaim="revisedClaim" :close="close" :commentApprover="commentApprover"
      :rules="rules" :comment_value="comment_value" :approveItem="approveItem" :toNumeral="toNumeral"
      @rejectItem="rejectItem" @cancelReject="cancelReject" :checkApprover="checkApprover"
      :approverCondition="approverCondition"></reimburse>
      <ess @closeDetails="closeDetails" :allApprover="allApprover" :approvalType="approval_type" @closeComments="closeComments"
      :loadingDetails="loadingDetails" :ess_name="ess_name" :details_ess="details_ess"
      :essNeedApproval="essNeedApproval" :index="index" :milisToDate="milisToDate" :firebaseUID="firebaseUID"
      :ess_comments="ess_comments" :milisToHour="milisToHour" :milisToTime="milisToTime"
      :data_ess="data_ess" :ess_approver="ess_approver" :ess_approver2="ess_approver2"
      :approveEss="approveEss" :revisedEss="revisedEss" :close="close" :commentApprover="commentApprover"
      :rules="rules" :comment_value="comment_value" :approveItem="approveItem" :toNumeral="toNumeral"
      @rejectItem="rejectItem" @cancelReject="cancelReject" :checkApprover="checkApprover"
      :approverCondition="approverCondition"></ess>
    <template>
      <v-dialog v-model="approvePopup" persistent max-width="300">
        <v-card>
          <v-card-title class="headline">{{$t('approve_data')}}</v-card-title>
          <v-card-text>
            <v-textarea :label="$t('comment')" v-model="comment"></v-textarea>
          </v-card-text>
          <v-card-text>{{$t('sure_approve')}}</v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
            <v-btn color="primary" :loading="loading" @click="approving(approvedItem)">{{$t('yes')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="rejectPopup" persistent max-width="300">
        <v-card>
          <v-card-title class="headline">{{$t('approve_data')}}</v-card-title>
          <v-card-text>{{$t('sure_reject')}}</v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
            <v-btn color="primary" :loading="loading" @click="updateReviseReject()">{{$t('yes')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>
<script>
  import axios from "axios";
  import firebase from "firebase";
  import moment from "moment";
  import momentDurationFormatSetup from "moment-duration-format"
  import ENV from "./../../../store/modules/environtment";
  import numeral from "numeral";
  import Correction from "./components/Correction.vue";
  import Leave from "./components/Leave.vue";
  import Overtime from "./components/Overtime.vue";
  import Reimburse from "./components/Reimburse.vue";
  import Ess from "./components/Ess.vue";

  momentDurationFormatSetup(moment)
  export default {
    name: "approval",
    components: {
      Correction,
      Leave,
      Overtime,
      Reimburse,
      Ess
    },
    data() {
      return {
        comment: '',
        leaveName: '',
        overtimeName: '',
        claimName: '',
        selectedCategory: 0,
        validator: this.$store.state.validator,
        baseUrl: this.$store.state.baseUrl,
        alert: false,
        alert_mode: "",
        alert_text: "",
        headers: [{
            text: this.$i18n.t('approval_code'),
            value: "id"
          },
          {
            text: this.$i18n.t('filling_date'),
            value: "submit_time"
          },
          {
            text: this.$i18n.t('employee_name'),
            value: "name"
          },
          {
            text: this.$i18n.t('category_approval'),
            value: "category"
          },
          {
            text: this.$i18n.t('status'),
            value: "status"
          },
        ],
        loadingDownload: false,
        approval: [],
        company_id: this.$store.state.company,
        search: "",
        detailsDialog: false,
        viewDialog: false,
        approveDialog: false,
        date: new Date().toISOString().substr(0, 10),
        start_date: "",
        end_date: "",
        downloadTitleStartDate: "",
        downloadTitleEndDate: "",
        menu_start: false,
        menu_end: false,
        loading: false,
        detailsItem: {},
        data_after: [],
        approval_id: [],
        user_id: [],
        data_before: [],
        approver_name: "",
        get_category: "",
        name_approver: "",
        name_approver2: "",
        commentDialog: false,
        commentDialog1: false,
        loadingDetails: false,
        details_approvall: [],
        approval_name: [],
        approvedItem: "l1Approved",
        approvedItem2: "l2Approved",
        rules: [(value) => !!value || this.$i18n.t('required')],
        valid: true,
        revised_reject: "",
        status_radio: "",
        comment_value: "",
        firebase_uid: this.$store.state.user.id,
        picked: "",
        timeoffDialog: false,
        comments: [],
        commentApprover: [],
        approveTimeoff: false,
        details_timeoff: [],
        timeOff_name: [],
        timeoff_approver: [],
        timeoff_approver2: [],
        comments_timeoff: [],
        timeoff_comments: [],
        revisedTimeoff: false,
        timeoff_image: [],
        user_list: [],
        user_activities: [],
        firebaseId: "",
        approvePopup: false,
        rejectPopup: false,
        index: null,
        images: [],
        status_reject: "l1Rejected",
        user_role: this.$store.state.user.role,
        approval_report: [],
        tmp_leave: [],
        tmp_correction: [],
        categoryLeave: [{
            name: this.$i18n.t('select_category_report'),
            id: 0
          },
          {
            name: this.$i18n.t('leave'),
            id: 1
          },
          {
            name: this.$i18n.t('correction'),
            id: 2
          },
          {
            name: this.$i18n.t('claim'),
            id: 3
          },
          {
            name: this.$i18n.t('overtime'),
            id: 4
          },
          {
            name: this.$i18n.t('switch-schedule'),
            id: 5
          },
        ],
        tmp_leave_approval: [],
        tmp_correction_approval: [],
        claimNeedApproval: false,
        details_claim: [],
        claim_name: [],
        claim_approver: [],
        claim_approver2: [],
        comments_claim: [],
        claim_comments: [],
        claim_image: [],
        data_claim: [],
        approveClaim: false,
        revisedClaim: false,
        essNeedApproval: false,
        details_ess: [],
        ess_name: [],
        ess_approver: [],
        ess_approver2: [],
        comments_ess: [],
        ess_comments: [],
        data_ess: [],
        approveEss: false,
        revisedEss: false,
        details_overtime: {
          overtime: {}
        },
        overtime_name: [],
        overtime_approver: [],
        overtime_approver2: [],
        comments_overtime: [],
        overtime_comments: [],
        overtime_image: [],
        data_overtime: [],
        approveOvertime: false,
        revisedOvertime: false,
        OvertimeNeedApproval: false,
        tmp_overtime_approval: [],
        categoryName: null,
        approval_type: null,
        allApprover: []
      };
    },
    computed: {
      checkFileExists() {
        if (this.approval_report == "") {
          return true;
        } else {
          return false;
        }
      },
      firebaseUID() {
        return this.firebase_uid
      },
      title() {
        return `Report ${this.categoryName} - ${this.$store.state.companyName
        } (${moment(this.downloadTitleStartDate).locale(this.$i18n.t('lang')).format("DD-MM-YYYY")} - ${moment(
          this.downloadTitleEndDate
        ).format("DD-MM-YYYY")}) .xls`;
      },
    },

    methods: {
      toNumeral(number) {
        return numeral(number).format("0,0");
      },
      milisToTime(milis) {
        let d = moment.duration(milis, "milliseconds");
        let hours = Math.floor(d.asHours());
        let mins = Math.floor(d.asMinutes()) - hours * 60;
        return this.toNumeral(hours) + " hrs " + mins + " min";
      },
      approveItem() {
        this.approvePopup = true;
      },
      rejectItem(comment, status) {
        this.comment_value = comment;
        this.status_radio = status;
        this.rejectPopup = true;
      },
      close() {
        this.commentDialog = false;
        this.approvePopup = false;
        this.rejectPopup = false;
      },
      checkReasonApproveColor(reason) {
        if (reason === "Edited" || reason === "On-Time") {
          return "success";
        }
      },
      checkNoteApproveColor(status) {
        if (status === "corrected") {
          return "success";
        }
      },
      checkReasonColor(reason) {
        if (reason === "-") {
          return;
        }
        if (reason === "On-Time") {
          return "success";
        } else {
          if (reason === "In-Tolerance") {
            return "warning";
          } else if (reason === null) {
            return "error";
          }
        }
      },
      checkNoteColor(note) {
        if (note === "In-Area") {
          return "success";
        } else {
          return "warning";
        }
      },
      openDetailsDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.detailsDialog = true;
        this.data_after = item;
        this.status_radio = "revised";
        this.fetchDetailsApproval(item.id);
      },
      viewDetailsDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.viewDialog = true;
        this.data_after = item;
        this.fetchDetailsApproval(item.id);
      },
      approvedDetailsDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.approveDialog = true;
        this.data_after = item;
        this.fetchDetailsApproval(item.id);
      },
      timeoffDetailsDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.timeoffDialog = true;
        this.status_radio = "revised";
        this.fetchDetailsTimeoff(item.id);
      },
      approveTimeoffDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.approveTimeoff = true;
        this.fetchDetailsTimeoff(item.id);
      },
      revisedTimeoffDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.revisedTimeoff = true;
        this.fetchDetailsTimeoff(item.id);
      },
      claimDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.claimNeedApproval = true;
        this.status_radio = "revised";
        this.fetchDetailsClaim(item.id);
      },
      approveClaimDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.approveClaim = true;
        this.fetchDetailsClaim(item.id);
      },
      revisedClaimDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.revisedClaim = true;
        this.fetchDetailsClaim(item.id);
      },
      OvertimeDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.OvertimeNeedApproval = true;
        this.status_radio = "revised";
        this.fetchDetailsOvertime(item.id);
      },
      approveOvertimeDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.approveOvertime = true;
        this.fetchDetailsOvertime(item.id);
      },
      revisedOvertimeDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.revisedOvertime = true;
        this.fetchDetailsOvertime(item.id);
      },
      essDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.essNeedApproval = true;
        this.status_radio = "revised";
        this.fetchDetailsEss(item.id);
      },
      approveEssDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.approveEss = true;
        this.fetchDetailsEss(item.id);
      },
      revisedEssDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = Object.assign({}, item);
        this.revisedEss = true;
        this.fetchDetailsEss(item.id);
      },
      onStartDateChange() {
        const diff = moment(this.end_date).locale(this.$i18n.t('lang')).diff(this.start_date, 'days')
        if (diff < 0) this.end_date = this.start_date
        this.menu_start = false;
      },
      onEndDateChange() {
        this.menu_end = false;
      },
      dateFormatted(date) {
        return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY");
      },
      milisToDate(milis) {
        return moment(milis, "x").locale(this.$i18n.t('lang')).format("DD/MM/YYYY");
      },
      milisToHour(milis) {
        return moment(milis, "x").locale(this.$i18n.t('lang')).format("Do MMMM YYYY, HH:mm");
      },
      milisToHourOnly(milis) {
        return moment(milis, "x").locale(this.$i18n.t('lang')).format("HH:mm:ss");
      },
      searching() {
        this.fetchUsersDownload();
        this.getListApproval();
        this.downloadReportApproval(0)
      },
      downloadReportApproval(event) {
        this.approval_report = [];
        this.approval = [];
        this.selectedCategory = event
        switch (event) {
          case 1:
            this.approval_report = this.tmp_leave;
            this.approval = this.tmp_leave_approval;
            this.categoryName = "Leave";
            break;
          case 2:
            this.approval_report = this.tmp_correction;
            this.approval = this.tmp_correction_approval;
            this.categoryName = "Correction";
            break;
          case 3:
            this.approval_report = this.tmp_claim;
            this.approval = this.tmp_claim_approval;
            this.categoryName = "Claim";
            break;
          case 4:
            this.approval_report = this.tmp_overtime;
            this.approval = this.tmp_overtime_approval;
            this.categoryName = "Overtime";
            break;
          case 5:
            this.approval_report = this.tmp_ess;
            this.approval = this.tmp_ess_approval;
            this.categoryName = "Switch-schedule";
            break;
          default:
            this.approval_report = [];
            this.approval = this.approval_id;
            this.categoryName = "-";
            break;
        }
      },
      async getListApproval() {
        let date_start = moment(this.start_date).locale(this.$i18n.t('lang')).format("DD-MM-YYYY");
        let date_end = moment(this.end_date).locale(this.$i18n.t('lang')).format("DD-MM-YYYY");
        const url =
          `${this.baseUrl}/approval/findbycompanyid?companyId=${this.company_id
        }` +
          "&status=" +
          "&start_date=" +
          date_start +
          "&end_date=" +
          date_end;
        this.tmp_leave_approval = [];
        this.tmp_correction_approval = [];
        this.tmp_claim_approval = [];
        this.tmp_overtime_approval = [];
        this.tmp_ess_approval = [];
        await axios
          .get(url, {
            headers: {
              action: "Get Approval",
              actionId: 4
            }
          })
          .then((res) => {
            this.approval = res.data.data;
            this.approval_id = res.data.data;

            this.approval_id.forEach((user) => {
              if (user.status == "submitted") {
                user.status = "Need Approval";
              }
              if (user.category == "time-off") {
                user.category = "Leave";
                this.tmp_leave_approval.push(user);
              }
              if (user.category == "correction") {
                this.tmp_correction_approval.push(user);
              }
              if (user.category == "reimburse") {
                user.category = "Claim";
                this.tmp_claim_approval.push(user);
              }
              if (user.category == "overtime") {
                this.tmp_overtime_approval.push(user);
              }
              if (user.category == "switch-schedule") {
                this.tmp_ess_approval.push(user);
              }
              user.category =
                user.category.charAt(0).toUpperCase() + user.category.slice(1);
              user["name"] = user.employee.full_name;
              this.user_id.push(user.id);
            });
            this.loading = false;
          });
        this.downloadReportApproval(this.selectedCategory)
      },
      fetchDetailsApproval(approval_id) {
        this.loadingDetails = true;
        const url =
          `${this.baseUrl}/approval/detail?approvalId=` +
          approval_id +
          "&category=correction";
        axios
          .get(url, {
            headers: {
              action: "Get Approval Detail",
              actionId: 4
            }
          })
          .then((res) => {
            this.data_after = res.data.data.after;
            this.data_before = res.data.data.before;
            
            this.details_approvall = res.data.data;
            this.approval_type = res.data.data.approval_type;
            this.approval_name = res.data.data.employee;
            
            this.allApprover = []
            if (res.data.data.approver) this.allApprover.push(res.data.data.approver);
            if (res.data.data.approver2) this.allApprover.push(res.data.data.approver2);

            this.comments = res.data.data.approval_comments;
            this.commentApprover = [];
            this.comments.forEach((user) => {
              this.commentApprover.push(user);
            });
            this.name_approver = res.data.data.approver;
            this.name_approver2 = res.data.data.approver2;
            

            this.revised_reject = res.data.data.id;
            this.loadingDetails = false;
          });
      },
      async updateReviseReject() {
        let param = {
          approvalId: this.revised_reject,
          comment: this.comment_value,
          status: this.status_radio,
          approverId: this.firebase_uid,
        };
        const url = `${this.baseUrl}/approval/updatestatus`;
        this.loading = true;
        await axios
          .post(url, param, {
            headers: {
              action: "Update Status Approval",
              actionId: 2
            },
          })
          .then(() => {
            this.detailsDialog = false;
            this.timeoffDialog = false;
            this.claimNeedApproval = false;
            this.essNeedApproval = false;
            this.OvertimeNeedApproval = false;
            this.rejectPopup = false;
            this.alert_text = "Data Successfully Saved";
            this.alert = true;
            this.alert_mode = "success";
            this.getListApproval();
          })
          .catch((err) => {
            this.alert_text = err.message;
            this.alert = true;
            this.loading = false;
            this.alert_mode = "error";
            // eslint-disable-next-line no-console
            console.error(err); // TODO: Add error toast message
          });
        this.downloadReportApproval(this.selectedCategory)
      },
      async approving() {
        let param = {
          id: this.revised_reject,
          status: "",
          approverId: this.firebase_uid,
          comment: this.comment.length > 0 ? this.comment : 'Approved'
        };

        if (this.details_timeoff.approver || this.details_timeoff.approver2) {
            if (this.details_timeoff.status == "submitted") {
              if(this.approval_type == 1) {
              param.status = this.approvedItem2;
              }else{
              param.status = this.approvedItem;
              }
            }
            if ((this.details_timeoff.status == "l1Approved" || this.details_timeoff.status == "approved")) {
              param.status = this.approvedItem2;
            }
        }

        if (this.details_approvall.approver || this.details_approvall.approver2) {
            if (this.details_approvall.status == "submitted") {
              if(this.approval_type == 1) {
                  param.status = this.approvedItem2;
                }else{
                  param.status = this.approvedItem;
                }
            }
            if ((this.details_approvall.status == "l1Approved" || this.details_approvall.status == "approved")) {
              param.status = this.approvedItem2;
            }
          
        }

        if (this.details_claim.approver || this.details_claim.approver2) {
            if (this.details_claim.status == "submitted") {
              if(this.approval_type == 1) {
              param.status = this.approvedItem2;
              }else{
              param.status = this.approvedItem;
              }
            }
            if ((this.details_claim.status == "l1Approved" || this.details_claim.status == "approved")) {
              param.status = this.approvedItem2;
            }
        }

        if (this.details_overtime.approver || this.details_overtime.approver2) {
            if (this.details_overtime.status == "submitted") {
             if(this.approval_type == 1) {
              param.status = this.approvedItem2;
              }else{
              param.status = this.approvedItem;
              }
            }
            if ((this.details_overtime.status == "l1Approved" || this.details_overtime.status == "approved")) {
              param.status = this.approvedItem2;
            }
        }

        if (this.details_ess.approver || this.details_ess.approver2) {
            if (this.details_ess.status == "submitted") {
              if(this.approval_type == 1) {
              param.status = this.approvedItem2;
              }else{
              param.status = this.approvedItem;
              }
            }
            if ((this.details_ess.status == "l1Approved" || this.details_ess.status == "approved")) {
              param.status = this.approvedItem2;
            }
        }

        let url = `${this.baseUrl}/approval/approving`;
        this.loading = true;
        await axios
          .post(url, param, {
            headers: {
              action: "Approval Approving",
              actionId: 2
            },
          })
          .then(() => {
            this.detailsDialog = false;
            this.timeoffDialog = false;
            this.claimNeedApproval = false;
            this.OvertimeNeedApproval = false;
            this.essNeedApproval = false;
            this.approvePopup = false;
            this.alert_text = "Data Successfully Saved";
            this.alert = true;
            this.alert_mode = "success";
            this.comment = ''
            this.getListApproval();
          })
          .catch((err) => {
            this.alert_text = err.message;
            this.alert = true;
            this.loading = false;
            this.alert_mode = "error";
            // eslint-disable-next-line no-console
            console.error(err); // TODO: Add error toast message
          });
        this.downloadReportApproval(this.selectedCategory)
      },
      fetchDetailsTimeoff(approval_id) {
        this.loadingDetails = true;
        const url =
          `${this.baseUrl}/approval/detail?approvalId=` +
          approval_id +
          "&category=time-off";
        axios
          .get(url, {
            headers: {
              action: "Get Approval Detail",
              actionId: 4
            }
          })
          .then((res) => {
            this.details_timeoff = res.data;
            this.details_timeoff.dateStart = this.details_timeoff.dates[0];
            this.details_timeoff.dateEnd = this.details_timeoff.dates[
              this.details_timeoff.dates.length - 1
            ];
            this.timeOff_name = res.data.employee;
            this.revised_reject = res.data.id;
            // this.approval_type = res.data.approval_type;
            this.approval_type = res.data.approver && res.data.approver2 ? 2 : 1;

            this.allApprover = []
            if (res.data.approver) this.allApprover.push(res.data.approver);
            if (res.data.approver2) this.allApprover.push(res.data.approver2);
            this.timeoff_approver = res.data.approver;
            this.timeoff_approver2 = res.data.approver2;
            this.timeoff_image = res.data.attached_image;
            this.comments_timeoff = res.data.approval_comments;
            this.timeoff_comments = [];
            this.comments_timeoff.forEach((user) => {
              this.timeoff_comments.push(user);
            });
            if(this.$i18n.t('lang') === 'en'){
              this.leaveName = res.data.leave_category.name_en;
            }else{
              this.leaveName = res.data.leave_category.name_id;
            }
            this.loadingDetails = false;
          });
      },
      fetchUserId() {
        this.loading = true;
        firebase
          .firestore()
          .collection(ENV.firebase.user)
          .where("company_id", "==", this.company_id)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              let user = doc.data();
              user.id = doc.id;
            });
            this.loading = false;
          });
      },
      fetchUsersDownload() {
        let date_start = moment(this.start_date).locale(this.$i18n.t('lang')).format("DD-MM-YYYY");
        let date_end = moment(this.end_date).locale(this.$i18n.t('lang')).format("DD-MM-YYYY");
        this.downloadTitleStartDate = this.start_date;
        this.downloadTitleEndDate = this.end_date;
        this.loadingDownload = true
        const url =
          `${this.baseUrl}/approval/downloadreport?companyId=${this.company_id}&startDate=${date_start}&endDate=${date_end}`;
        axios
          .get(url, {
            headers: {
              action: "Approval Download Report",
              actionId: 4
            },
          })
          .then((res) => {
            this.tmp_leave = [];
            this.tmp_correction = [];
            this.tmp_claim = [];
            this.tmp_overtime = [];
            this.tmp_ess = [];
            res.data.data.leaves.forEach((row) => {
              let reportLeave = {};
              reportLeave["Submit Date"] = this.milisToDate(row.submit_timestamp);
              reportLeave["Full Name"] = row.employee.full_name;
              reportLeave["Category"] = row.leave_category.name_en;
              reportLeave["Description"] = row.description;
              reportLeave["Start Date"] = this.milisToDate(row.dates[0]);
              reportLeave["End Date"] = this.milisToDate(
                row.dates[row.dates.length - 1]
              );
              reportLeave["Total Days"] = row.total_days;
              reportLeave["Status Approval"] = row.status;
              reportLeave["Attachment"] = row.attached_image[0];
              if (row.approver == null) {
                reportLeave["Approval1"] = row.approver = {
                  full_name: "No Name",
                };
              } else {
                reportLeave["Approval1"] = row.approver.full_name;
              }
              if (row.approver2 == null) {
                reportLeave["Approval2"] = row.approver = {
                  full_name: "No Name",
                };
              } else {
                reportLeave["Approval2"] = row.approver2.full_name;
              }
              this.tmp_leave.push(reportLeave);
            });

            res.data.data.corrections.forEach((row) => {
              let reportCorrection = {};
              reportCorrection["Submit Date"] = this.milisToDate(
                row.submit_timestamp
              );
              reportCorrection["Full Name"] = row.employee.full_name;
              reportCorrection["Correction Date"] = this.milisToDate(
                row.after.time_in_after
              );
              reportCorrection["Status Approval"] = row.status;
              if (row.approver == null) {
                reportCorrection["Approval1"] = row.approver = {
                  full_name: "No Name",
                };
              } else {
                reportCorrection["Approval1"] = row.approver.full_name;
              }
              if (row.approver2 == null) {
                reportCorrection["Approval2"] = row.approver = {
                  full_name: "No Name",
                };
              } else {
                reportCorrection["Approval2"] = row.approver2.full_name;
              }
              this.tmp_correction.push(reportCorrection);
            });

            res.data.data.reimburse.forEach((row) => {
              let reportClaim = {};
              reportClaim["Submit Date"] = this.milisToDate(row.submit_timestamp);
              reportClaim["Full Name"] = row.employee.full_name;
              reportClaim["Category"] = row.reimburse_category.name_en;
              reportClaim["Description"] = row.notes;
              reportClaim["Total"] = row.total;
              reportClaim["Date"] = row.date;
              reportClaim["Status Approval"] = row.status;
              reportClaim["Attachment"] = row.attached_image[0];
              if (row.approver == null) {
                reportClaim["Approval1"] = row.approver = {
                  full_name: "No Name",
                };
              } else {
                reportClaim["Approval1"] = row.approver.full_name;
              }
              if (row.approver2 == null) {
                reportClaim["Approval2"] = row.approver = {
                  full_name: "No Name",
                };
              } else {
                reportClaim["Approval2"] = row.approver2.full_name;
              }
              this.tmp_claim.push(reportClaim);
            });

            res.data.data.overtime.forEach((row) => {
              let reportOvertime = {};
              reportOvertime["Submit Date"] = this.milisToDate(row.submit_timestamp)
              reportOvertime["Full Name"] = row.employee.full_name;
              reportOvertime["Category"] = row.overtime_category.name_en;
              reportOvertime["Description"] = row.message;
              reportOvertime["Overtime Date"] = moment(row.date_milis, 'x').locale(this.$i18n.t('lang')).format("DD/MM/YYYY");
              reportOvertime["Start Time"] = row.start_time;
              reportOvertime["End Time"] = row.end_time;
              reportOvertime["Duration"] = moment.duration(row.duration, 'millisecond').format("hh:mm:ss")
              reportOvertime["Status Approval"] = row.status;
              reportOvertime["Attachment"] = row.attached_image[0];
              if (row.approver == null) {
                reportOvertime["Approval1"] = row.approver = {
                  full_name: "No Name"
                }
              } else {
                reportOvertime["Approval1"] = row.approver.full_name;
              }
              if (row.approver2 == null) {
                reportOvertime["Approval2"] = row.approver = {
                  full_name: "No Name"
                }
              } else {
                reportOvertime["Approval2"] = row.approver2.full_name;
              }
              this.tmp_overtime.push(reportOvertime);
            })

            // res.data.data.ess.forEach((row) => {
            //   let reportEss = {};
            //   reportEss["Submit Date"] = this.milisToDate(row.submit_timestamp);
            //   reportEss["Full Name"] = row.employee.full_name;
            //   reportEss["Category"] = row.reimburse_category.name_en;
            //   reportEss["Description"] = row.notes;
            //   reportEss["Total"] = row.total;
            //   reportEss["Date"] = row.date;
            //   reportEss["Status Approval"] = row.status;
            //   reportEss["Attachment"] = row.attached_image[0];
            //   if (row.approver == null) {
            //     reportEss["Approval1"] = row.approver = {
            //       full_name: "No Name",
            //     };
            //   } else {
            //     reportEss["Approval1"] = row.approver.full_name;
            //   }
            //   if (row.approver2 == null) {
            //     reportEss["Approval2"] = row.approver = {
            //       full_name: "No Name",
            //     };
            //   } else {
            //     reportEss["Approval2"] = row.approver2.full_name;
            //   }
            //   this.tmp_ess.push(reportEss);
            // });

            this.loadingDownload = false
          })
          .catch((err) => {
            this.loadingDownload = false
            // eslint-disable-next-line no-console
            console.error(err);
          });
      },
      checkApprover(foo) {
        if (foo) {
          return 'Approver 2'
        } else {
          return 'Approver'
        }
      },
      approverCondition(approver, status) {
        if (approver == 1) {
          if ((status == 'l1Approved' || status == 'approved') || (status == 'l2Approved' || status == 'approved') || status == 'l2Rejected' || status == 'l2Revised') {
            return this.$i18n.t('approved_by')
          } else if (status == 'l1Revised') {
            return this.$i18n.t('revised_by')
          } else if (status == 'l1Rejected') {
            return this.$i18n.t('rejected_by')
          } else if (status == 'submitted') {
            return this.$i18n.t('waiting_approval_from')
          }
        } else if (approver == 2) {
          if ((status == 'l1Approved' || status == 'approved') || status == 'l1Revised' || status == 'submitted') {
            return this.$i18n.t('waiting_approval_from')
          } else if ((status == 'l2Approved' || status == 'approved')) {
            return this.$i18n.t('approved_by')
          } else if (status == 'l2Rejected') {
            return this.$i18n.t('rejected_by')
          } else if (status == 'l2Revised') {
            return this.$i18n.t('revised_by')
          }
        }
      },
      closeDetails() {
        this.allApprover = [];
        this.detailsDialog = false;
        this.viewDialog = false;
        this.approveDialog = false;
        this.timeoffDialog = false;
        this.revisedTimeoff = false;
        this.approveTimeoff = false;
        this.OvertimeNeedApproval = false;
        this.approveOvertime = false;
        this.revisedOvertime = false;
        this.claimNeedApproval = false;
        this.approveClaim = false;
        this.revisedClaim = false;
        this.essNeedApproval = false;
        this.approveEss = false;
        this.revisedEss = false;
      },
      cancelReject(foo) {
        this.commentDialog1 = foo;
      },
      closeComments() {

        this.commentDialog = false;
      },
      fetchDetailsClaim(approval_id) {
        this.loadingDetails = true;
        const url = `${this.baseUrl}/approval/detail?approvalId=${approval_id}&category=reimburse`;
        axios
          .get(url, {
            headers: {
              action: "Get Approval Detail",
              actionId: 4
            }
          })
          .then((res) => {
            this.revised_reject = res.data.id;
            this.details_claim = res.data;
            this.claim_name = res.data.employee;
            this.claim_approver = res.data.approver;
            this.claim_approver2 = res.data.approver2;
            // this.approval_type = res.data.approval_type;
            this.approval_type = res.data.approver && res.data.approver2 ? 2 : 1;

            this.allApprover = []
            if (res.data.approver) this.allApprover.push(res.data.approver);
            if (res.data.approver2) this.allApprover.push(res.data.approver2);
            this.claim_image = res.data.attached_image;
            this.comments_claim = res.data.approval_comments;
            this.claim_comments = [];
            this.comments_claim.forEach((user) => {
              this.claim_comments.push(user);
            });
            if(this.$i18n.t('lang') === 'en'){
              this.claimName = res.data.reimburse_category.name_en;
            }else{
              this.claimName = res.data.reimburse_category.name_id;
            }
            this.data_claim = res.data.reimburses[0];
            this.claim_image = res.data.attached_image;
            this.loadingDetails = false;
          });
      },
      fetchDetailsOvertime(approval_id) {
        this.loadingDetails = true;
        const url = `${this.baseUrl}/approval/detail?approvalId=${approval_id}&category=overtime`;
        axios
          .get(url, {
            headers: {
              action: "Get Approval Detail",
              actionId: 4
            }
          })
          .then((res) => {
            this.revised_reject = res.data.id;
            this.details_overtime = res.data;
            this.overtime_name = res.data.employee;
            this.overtime_approver = res.data.approver;
            this.overtime_approver2 = res.data.approver2;
            // this.approval_type = res.data.approval_type;
            this.approval_type = res.data.approver && res.data.approver2 ? 2 : 1;

            this.allApprover = []
            if (res.data.approver) this.allApprover.push(res.data.approver);
            if (res.data.approver2) this.allApprover.push(res.data.approver2);
            this.overtime_image = res.data.attached_image;
            this.comments_overtime = res.data.approval_comments;
            this.overtime_comments = [];
            this.comments_overtime.forEach((user) => {
              this.overtime_comments.push(user);
            });
           if(this.$i18n.t('lang') === 'en'){
              this.overtimeName = res.data.overtime_category.name_en;
            }else{
              this.overtimeName = res.data.overtime_category.name_id;
            }
            this.data_overtime = res.data.overtime;
            this.loadingDetails = false;
          });
      },
      fetchDetailsEss(approval_id) {
        this.loadingDetails = true;
        const url = `${this.baseUrl}/approval/detail?approvalId=${approval_id}&category=switch-schedule`;
        axios
          .get(url, {
            headers: {
              action: "Get Approval Detail",
              actionId: 4
            }
          })
          .then((res) => {
            this.revised_reject = res.data.data.id;
            this.details_ess = res.data.data;
            this.ess_name = res.data.data.employee;
            this.ess_approver = res.data.data.approver;
            this.ess_approver2 = res.data.data.approver2;
            // this.approval_type = res.data.data.switchSchedule.approval_type;
            this.approval_type = res.data.data.approver && res.data.data.approver2 ? 2 : 1;
            if (res.data.data.approver) this.allApprover.push(res.data.data.approver);
            if (res.data.data.approver2) this.allApprover.push(res.data.data.approver2);
            this.comments_ess = res.data.data.approval_comments;
            this.ess_comments = [];
            this.comments_ess.forEach((user) => {
              this.ess_comments.push(user);
            });
            this.data_ess = res.data.data.switchSchedule;
            this.loadingDetails = false;
          });
      },
    },
    created() {
      this.allApprover = []
      this.start_date = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      this.end_date = moment().locale(this.$i18n.t('lang')).format("YYYY-MM-DD");
      this.downloadTitleStartDate = this.start_date;
      this.downloadTitleEndDate = this.end_date
      this.getListApproval();
      // this.fetchDetailsApproval();
      // this.fetchDetailsTimeoff();
      this.fetchUserId();
      this.fetchUsersDownload();
      // this.fetchDetailsClaim();
      // this.fetchDetailsOvertime();
    },
  };
</script>
<style scoped>
  .v-divider {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .blueimp-gallery {
    background: rgba(0, 0, 0, 0.7) !important;
  }

  .blueimp-gallery-display {
    display: block;
    opacity: 1;
  }
</style>